import React, { useState, useCallback, useMemo } from "react";
import { Field, Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { LoadingButton } from "../../../components/LoadingButton";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { AdministrateSelectInput, AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const EditClinicPayorMappingModal = ({ clinicId, mapping, onSave, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleAdd = useCallback(
    async (params) => {
      setError(null);

      try {
        await api.put(`/admin/clinic_payor_mappings/${mapping.id}`, snakifyKeys({ ...params, clinicId }));

        if (onSave) {
          onSave("Updated Clinic Payor Mapping");
        }

        setOpen(false);
      } catch (err) {
        setError(err);
      }
    },
    [clinicId, mapping?.id, onSave]
  );

  const initialValues = useMemo(() => ({ payorId: mapping.payor.id, insuranceName: mapping.insuranceName }), [mapping]);

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Clinic Payor Mapping</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleAdd} initialValues={initialValues}>
            {({ handleSubmit, submitting }) => {
              return (
                <>
                  <Field
                    component={AdminOptionableInput}
                    resource="payors"
                    queryParams={{ supported_clinics: { id: clinicId } }}
                    label="Payor"
                    name="payorId"
                    searchParam="name"
                    required
                  />

                  <Field label="Provided Payor Name" name="insuranceName" component={TextInput} required />

                  <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
                    Submit
                  </LoadingButton>
                </>
              );
            }}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
